var _style, _rect, _rect2, _ellipse, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireWarningDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.8,
    className: "st0",
    width: 10.4,
    height: 10.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 6.3,
    className: "st0",
    width: 6.9,
    height: 3.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 5.7,
    cy: 8,
    rx: 1.1,
    ry: 1.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.7,
    y1: 8,
    x2: 12,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.5,
    y1: 8,
    x2: 13.7,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.3,
    y1: 8,
    x2: 15.5,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.5,
    y1: 6.4,
    x2: 15.5,
    y2: 9.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireWarningDevice);
export default __webpack_public_path__ + "static/media/FireWarningDevice.effa6b263ac5dbf5d6899d7aee65da09.svg";
export { ForwardRef as ReactComponent };